import enUS from './en-US';
import esES from './es-ES';
import deDE from './de-DE';
import zhCN from './zh-CN';
import zhTW from './zh-TW';
import frFR from './fr-FR';
import ptBR from './pt-BR';
import jaJP from './ja-JP';
import ruRU from './ru-RU';
import koKR from './ko-KR';
import itIT from './it-IT';
import viVN from './vi-VN';
import plPL from './pl-PL';
import trTR from './tr-TR';
import idID from './id-ID';
import nlNL from './nl-NL';
import svSE from './sv-SE';
const defaultZoomLocaleMap = {
    'en-US': enUS,
};
export function getDefaultZoomLocaleMap() {
    return defaultZoomLocaleMap;
}
/* react-ui/entry-ignore-export-name: es_ES */
export const es_ES = { 'es-ES': esES };
/* react-ui/entry-ignore-export-name: de_DE */
export const de_DE = { 'de-DE': deDE };
/* react-ui/entry-ignore-export-name: zh_CN */
export const zh_CN = { 'zh-CN': zhCN };
/* react-ui/entry-ignore-export-name: zh_TW */
export const zh_TW = { 'zh-TW': zhTW };
/* react-ui/entry-ignore-export-name: fr_FR */
export const fr_FR = { 'fr-FR': frFR };
/* react-ui/entry-ignore-export-name: ja_JP */
export const ja_JP = { 'ja-JP': jaJP };
/* react-ui/entry-ignore-export-name: pt_BR */
export const pt_BR = { 'pt-BR': ptBR };
/* react-ui/entry-ignore-export-name: ru_RU */
export const ru_RU = { 'ru-RU': ruRU };
/* react-ui/entry-ignore-export-name: ko_KR */
export const ko_KR = { 'ko-KR': koKR };
/* react-ui/entry-ignore-export-name: it_IT */
export const it_IT = { 'it-IT': itIT };
/* react-ui/entry-ignore-export-name: vi_VN */
export const vi_VN = { 'vi-VN': viVN };
/* react-ui/entry-ignore-export-name: pl_PL */
export const pl_PL = { 'pl-PL': plPL };
/* react-ui/entry-ignore-export-name: tr_TR */
export const tr_TR = { 'tr-TR': trTR };
/* react-ui/entry-ignore-export-name: id_ID */
export const id_ID = { 'id-ID': idID };
/* react-ui/entry-ignore-export-name: nl_NL */
export const nl_NL = { 'nl-NL': nlNL };
/* react-ui/entry-ignore-export-name: sv_SE */
export const sv_SE = { 'sv-SE': svSE };
export const allLocales = {
    'es-ES': esES,
    'de-DE': deDE,
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'fr-FR': frFR,
    'pt-BR': ptBR,
    'ja-JP': jaJP,
    'ru-RU': ruRU,
    'ko-KR': koKR,
    'it-IT': itIT,
    'vi-VN': viVN,
    'pl-PL': plPL,
    'tr-TR': trTR,
    'id-ID': idID,
    'nl-NL': nlNL,
    'sv-SE': svSE,
};
export function getDefaultZoomLocaleKey() {
    return 'en-US';
}
